export const SITE = {
  brand: "Swedcro",
  tagline: "Måleri & Fasad",
  phone: "072-271 74 41",
  phoneHref: "tel:+46722717441",
  email: "info@swedcro.se",
  city: "Eskilstuna",
  area: "Eskilstuna & närområdet",
  logo: "https://customer-assets.emergentagent.com/job_2f7d6ed8-3157-455a-a29f-d9dd7fed6618/artifacts/osu3jwup_1780780110539.png",
  hero: "/hero/hero-1920.webp",
  facebook: "https://www.facebook.com/share/1EimBAzx3p/",
  instagram: "https://www.instagram.com/swedcromaleri?igsh=aHB3Y2h6YXg0bWZ6",
};

export const SERVICES = [
  {
    id: "maleri",
    galleryCategory: "maleri",
    slideshowTags: ["maleri"],
    title: "Måleri",
    short:
      "Vi förvandlar dina ytor med fokus på ett felfritt slutresultat – från väggar och tak till detaljer, fasader och fönster.",
    details: [
      {
        title: "Väggar & tak",
        text:
          "Vi förvandlar dina ytor med fokus på ett felfritt slutresultat. Oavsett om det gäller en modern uppfräschning eller ett färgbyte, garanterar vi jämna ytor, skarpa kanter och en hållbar finish som ger rummet en helt ny karaktär och känsla.",
      },
      {
        title: "Snickerier & dörrar",
        text:
          "Detaljerna gör hela skillnaden i ett hem. Vi utför precisionsmålning av lister, foder, dörrar och platsbyggd inredning. Med rätt förarbete och noggrann penselföring ser vi till att dina snickerier får en slitstark yta och en finish som imponerar.",
      },
      {
        title: "Fasader",
        text:
          "Din fasad är husets ansikte utåt och kräver rätt skydd mot det nordiska klimatet. Vi erbjuder professionell fasadmålning och renovering som inte bara förbättrar husets estetik, utan även effektivt skyddar materialet mot fukt, vind och slitage för att bevara och öka fastighetens värde.",
      },
      {
        title: "Fönstermålning",
        text:
          "Vi utför noggrann fönsterrenovering och målning där vi ser över skicket, förbereder ytorna och använder högkvalitativ färg. Detta förlänger fönstrens livslängd och ger ett estetiskt tilltalande resultat.",
      },
    ],
    bullets: ["Väggar & tak", "Snickerier & dörrar", "Fasader", "Fönstermålning"],
    image:
      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    icon: "Paintbrush",
  },
  {
    id: "renovering",
    galleryCategory: "renovering",
    slideshowTags: ["renovering"],
    title: "Renovering",
    short: "Helhetslösningar för rum eller hela hemmet – från spackling till färdig yta.",
    bullets: ["Spackel & slipning", "Lister & foder", "Totalrenovering"],
    image:
      "https://images.pexels.com/photos/6474135/pexels-photo-6474135.jpeg?auto=compress&cs=tinysrgb&w=1400&q=85",
    icon: "Hammer",
  },
  {
    id: "tapetsering",
    galleryCategory: "tapetsering",
    slideshowTags: ["tapetsering"],
    title: "Tapetsering",
    short: "Professionell tapetsering med raka skarvar och perfekta mönsterpassningar.",
    bullets: ["Tapetborttagning", "Förarbete av väggar", "Mönster & enfärgat"],
    image:
      "https://kungsgatan69.se/storage/1D8FA7E506FF981B19A0A241EA822DBD3DAC6BC4EB9132B7037563263ADD818F/e488d2cf512c4dad93d79915b63e0fd4/jpg/media/cd63ebaea5a64d8dbe4b07474bd9d5ab/photowalls2%204x5.jpg?io=yes&auto=webp&width=1200&quality=75",
    icon: "Layers",
  },
  {
    id: "fasad",
    galleryCategory: "fasad-sockelputs",
    slideshowTags: ["fasad"],
    title: "Akrylfasad med Rockwool-isolering & Träfasad",
    short:
      "Tilläggsisolering med akrylputs och renovering av träfasader – skydd och ny look för husets ansikte utåt.",
    details: [
      {
        title: "Akrylfasad med Rockwool-isolering",
        text:
          "Professionella fasadlösningar med Rockwool-isolering och akrylputs. Rockwool-skivor ger en robust och brandsäker grund, medan akrylputsen ger en flexibel, hållbar och väderbeständig finish med ett modernt utseende.",
      },
      {
        title: "Träfasad",
        text:
          "Vi utför renovering och målning av träfasader med noggrant förarbete. Arbetet kan omfatta tvätt, skrapning, slipning, grundmålning och färdigmålning för ett hållbart och snyggt resultat. Metod och material anpassas efter fasadens skick och förutsättningar.",
      },
    ],
    bullets: ["Akrylfasad med Rockwool", "Träfasad – tvätt, slipning & målning", "Kulörval & prover"],
    image: "/services/fasad-villa.webp",
    icon: "Home",
  },
  {
    id: "mosaik",
    galleryCategory: "mosaik-marmorsten",
    slideshowTags: ["mosaik-sockelputs"],
    title: "Mosaik / Sockelputs & Marmorsten",
    short:
      "Tåliga och dekorativa stenlösningar för sockel, trappor och terrasser – i valfri kulör.",
    details: [
      {
        title: "Mosaik / Sockelputs",
        text:
          "Dekorativ och slitstark sockelputs med färgad sten som ger husgrunden ett snyggt, tåligt och tidlöst uttryck. Passar både renovering och nya ytor och ger en hållbar finish för utomhusmiljö.",
      },
      {
        title: "Marmorsten / Stenmatta",
        text:
          "Marmorsten erbjuder många möjligheter för stenmatta, trappor, terrassgolv och andra utomhusbeläggningar. Stenarna är tvättade, siktade och torkade och består av naturmaterial. Eftersom det är natursten kan färgvariationer förekomma.",
      },
    ],
    bullets: ["Sockelputs med färgad sten", "Stenmatta & trappor", "Terrassgolv"],
    image: "/services/mosaik-stairs.webp",
    samples: [
      { src: "/mosaik-samples/sample-m2-320.jpg", label: "M2 320" },
      { src: "/mosaik-samples/sample-m4-136.jpg", label: "M4 136" },
      { src: "/mosaik-samples/sample-m9-888.jpg", label: "M9 888" },
      { src: "/mosaik-samples/sample-m9-922.jpg", label: "M9 922" },
      { src: "/mosaik-samples/sample-m9-924.jpg", label: "M9 924" },
    ],
    icon: "Brush",
  },
];

export const TESTIMONIALS = [
  {
    name: "Anders K.",
    place: "Villaägare, Eskilstuna",
    text:
      "Otroligt nöjd! Killarna målade hela fasaden snabbt och prydligt. Bra kommunikation från första kontakt till sista penseldraget.",
  },
  {
    name: "Linda P.",
    place: "Lägenhet, Torshälla",
    text:
      "Tapetseringen blev perfekt – raka skarvar och inga blåsor. Rent och städat efter arbetet. Rekommenderar varmt.",
  },
  {
    name: "Marko S.",
    place: "Radhus, Kjula",
    text:
      "Fasaden ser fantastisk ut. Professionellt utförande, hederligt pris och ärlig offert utan överraskningar.",
  },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1774977737078-7ccc2ac697e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxob3VzZSUyMGV4dGVyaW9yJTIwcGFpbnRpbmd8ZW58MHx8fHwxNzgwODMyOTgwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1647579350449-37960d792a05?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxob3VzZSUyMGV4dGVyaW9yJTIwcGFpbnRpbmd8ZW58MHx8fHwxNzgwODMyOTgwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1628624747186-a941c476b7ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGV4dGVyaW9yJTIwcGFpbnRpbmd8ZW58MHx8fHwxNzgwODMyOTgwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/14613134/pexels-photo-14613134.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1688918511009-0b3992e6b020?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxpbnRlcmlvciUyMHdhbGxwYXBlcmluZyUyMGhvbWV8ZW58MHx8fHwxNzgwODMyOTgwfDA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/5242049/pexels-photo-5242049.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export const GOOGLE_PLACE_ID = "ChIJn4ubGNM4uIIR8ShfJ2PydPY";
export const GOOGLE_MAPS_URL = "https://maps.app.goo.gl/wfx7wXvBTfyFSAcF6";
export const GOOGLE_WRITE_REVIEW_URL = `https://search.google.com/local/writereview?placeid=${GOOGLE_PLACE_ID}`;
